module.exports = __webpack_public_path__ + "img/167.82dd857f.jpg";